import { Outlet } from "react-router-dom";

const LoanOfficer = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default LoanOfficer;
